/**
 * Cloud Functions (mesma região do deploy em `backend/functions`).
 * Evita strings soltas no cliente.
 */

/** Região onde as functions foram publicadas (ex.: `setGlobalOptions({ region })`). */
export const FIREBASE_FUNCTIONS_REGION = 'southamerica-east1' as const;

/** Callable que cria Checkout Session (assinatura) no Stripe. */
export const CLOUD_FUNCTION_CREATE_STRIPE_CHECKOUT_SESSION =
  'createStripeCheckoutSession' as const;

/** Callable que ativa plano gratuito (sem checkout). */
export const CLOUD_FUNCTION_ACTIVATE_FREE_PLAN = 'activateFreePlan' as const;

/** Callable que agenda cancelamento da assinatura ao fim do período (Stripe). */
export const CLOUD_FUNCTION_CANCEL_STRIPE_SUBSCRIPTION_AT_PERIOD_END =
  'cancelStripeSubscriptionAtPeriodEnd' as const;

/** Callable que envia mensagem de teste no WhatsApp. */
export const CLOUD_FUNCTION_SEND_WHATSAPP_TEST_MESSAGE =
  'sendWhatsAppTestMessage' as const;
